import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  // Load from localStorage on mount
  useEffect(() => {
    const savedCart = window.localStorage.getItem('keylodia-store-cart');
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch (error) {
        console.error('Failed to parse cart:', error);
      }
    }
    setIsInitialized(true);
  }, []);

  // Save to localStorage whenever cart changes
  useEffect(() => {
    if (isInitialized) {
      window.localStorage.setItem('keylodia-store-cart', JSON.stringify(cart));
    }
  }, [cart, isInitialized]);

  // ADD or INCREASE QUANTITY
  const addToCart = (item) => {
    setCart((prevCart) => {
      // 1. Create a unique ID combining the product ID and its variant
      const uniqueCartId = `${item.id}-${item.variant}`;
      
      // 2. Search using this new unique ID
      const existingItem = prevCart.find((cartItem) => cartItem.cartItemId === uniqueCartId);
      
      if (existingItem) {
        return prevCart.map((cartItem) =>
          cartItem.cartItemId === uniqueCartId
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
      
      // 3. Save the new unique ID into the cart item object
      return [...prevCart, { ...item, quantity: 1, cartItemId: uniqueCartId }];
    });
  };

  // DECREASE QUANTITY (Now expects the unique cartItemId)
  const decreaseQuantity = (cartItemId) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((cartItem) => cartItem.cartItemId === cartItemId);
      
      if (existingItem?.quantity === 1) {
        return prevCart.filter((cartItem) => cartItem.cartItemId !== cartItemId);
      }
      
      return prevCart.map((cartItem) =>
        cartItem.cartItemId === cartItemId
          ? { ...cartItem, quantity: cartItem.quantity - 1 }
          : cartItem
      );
    });
  };

  // COMPLETELY REMOVE ITEM (Now expects the unique cartItemId)
  const removeFromCart = (cartItemId) => {
    setCart((prevCart) => prevCart.filter((cartItem) => cartItem.cartItemId !== cartItemId));
  };

  const clearCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider 
      value={{ cart, addToCart, decreaseQuantity, removeFromCart, clearCart }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);